import { Box, FormControlLabel, Link, Radio, RadioGroup, Typography } from '@mui/material'
import { FormLabel, MButton } from 'components'
import { ROUTES_PATH } from 'config'
import { color } from 'config/color'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { type InformationFormType, type PremiseType } from './ServiceForm'

interface SelectAddressFormProps {
    handleNext: () => void
    handleBack: () => void
    premiseList: PremiseType[] | undefined
    formData: InformationFormType
    setFormData: (data: InformationFormType) => void
}

const SelectAddressForm: React.FC<SelectAddressFormProps> = ({ handleNext, handleBack, formData, setFormData, premiseList }: SelectAddressFormProps) => {
    const isMobile = useMobileBreakpoints()
    const [selectedAddress, setSelectedAddress] = useState<string>('')

    const handleSubmit = async (): Promise<void> => {
        try {
            setFormData({ ...formData, selectedAddress })
            handleNext()
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if ((formData?.selectedAddress) != null) {
            setSelectedAddress(formData?.selectedAddress)
        }
    }, [formData])


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setSelectedAddress((event.target as HTMLInputElement).value)
    }

    return (
        <Box>
            <Typography fontSize={16} fontWeight={600} mb={1}>Great News!</Typography>
            <Typography fontSize={16} mb={2}>We have found <b>{premiseList?.length} addresses</b> that matches with the provided information, please select which is the address were you want to request this service.
                Don&apos;t see your address in the list? Try entering your information again or please <Link href={ROUTES_PATH.CONTACT_US}>Contact Us</Link>.</Typography>
            <Box sx={{ width: '100%', py: 2, maxHeight: 200, overflow: 'auto', borderTop: `solid 1px ${color.grey[300]}`, borderBottom: `solid 1px ${color.grey[300]}` }}>
                <FormLabel>ADDRESS</FormLabel>
                <RadioGroup value={selectedAddress} onChange={handleChange}>
                    {premiseList?.map((premise, index) => <FormControlLabel key={index} value={premise.premiseInfo} control={<Radio />} label={premise.premiseInfo} />)}
                </RadioGroup>
            </Box>
            <Box display="flex" my={3} width={isMobile ? '100%' : '50%'} flexDirection={isMobile ? 'column' : 'row'} gap={2}>
                <MButton fullWidth variant='outlined' texttransform='none' rounded='true' onClick={() => { handleBack() }}>
                    Back
                </MButton>
                <MButton fullWidth variant='contained' type='submit' texttransform='none' rounded='true' disabled={selectedAddress === ''} onClick={handleSubmit}>
                    Confirm Address
                </MButton>
            </Box>
        </Box>
    )
}

export default SelectAddressForm
